import { put, call } from 'redux-saga/effects';
import readJsonDataService from '../../services/readJsonData.services';
import { constants } from '../../constants';
import { decompress } from 'compress-json';

import { 
  getInstitutionsSuccess,
  getInstitutionsError,
  toggleAlertShowStatus} from '../actions';


export default function * getInstitutionList () {
  try {
    for(let i=0; i<= 3; i++){
      const res = yield call([readJsonDataService, 'getInstitutionList'], `institutionList_${i}.json`);
      //making sure redux store will update if api save is successful
      const decompedJson = decompress(res.body);
      yield put(getInstitutionsSuccess(decompedJson));
    }
  } catch (error) {
    yield put(toggleAlertShowStatus({
      showAlert: true,
      alertVarient:'danger',
      alertMessage: constants.APP_MESSAGE.API_RETRIVE_ERROR
    }));

    yield put(getInstitutionsError()) 
  }
}
